import { render, staticRenderFns } from "./WasteBinReadingModal.yaml?vue&type=template&id=2876fe4a&component"
import script from "./WasteBinReadingModal.yaml?vue&type=script&lang=ts&component"
export * from "./WasteBinReadingModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports